import styled from 'styled-components';

import grid from '~/styles/grid';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${grid.xs};
  width: 100%;
  margin-bottom: 1.7rem;

  .MuiChip-deleteIcon {
    width: 16px;

    &:hover {
      color: #4d4d4d;
    }
  }
`;

export const ClearFiltersButton = styled.button`
  font-size: 1rem;
  padding: ${grid.xs};
  color: #1a1a1a;
  border: 2px solid #1a1a1a;
  background: none;
  border-radius: 5px;
`;
